import { Component } from '@angular/core';

@Component({
  selector: 'app-comparison-retirement-types',
  templateUrl: './comparison-retirement-types.component.html',
  styleUrls: ['./comparison-retirement-types.component.scss']
})
export class ComparisonRetirementTypesComponent {

}
